type WindowWithBroadcastChannelId = Window & {
  __plutoBroadcastChannelId?: string;
};

function createBroadcastChannelId() {
  return crypto.randomUUID();
}

export function getBroadcastChannelId() {
  const currentWindow = window as WindowWithBroadcastChannelId;
  currentWindow.__plutoBroadcastChannelId ??= createBroadcastChannelId();
  return currentWindow.__plutoBroadcastChannelId;
}

export function isBroadcastChannelMessageFromCurrentWindow(channelId: string) {
  return channelId === getBroadcastChannelId();
}

export function createBroadcastChannel(channelName: string): BroadcastChannel | undefined {
  if (typeof BroadcastChannel === 'undefined') {
    return undefined;
  }

  try {
    return new BroadcastChannel(channelName);
  } catch {
    // BroadcastChannel can be disabled by browser privacy settings.
    return undefined;
  }
}

export function postBroadcastMessage(channelName: string, message: unknown) {
  const channel = createBroadcastChannel(channelName);
  if (!channel) {
    return;
  }

  try {
    channel.postMessage(message);
  } catch {
    // Cross-tab notifications must not prevent the local action from completing.
  } finally {
    channel.close();
  }
}
